import { Button } from "@mozioinc/ui";
import { useTranslation } from "react-i18next";
import { HeaderSwitch } from "../containers/header-switch";
import WarningSvg from "./assets/warning.svg?react";
import { PreservedLink } from "./preserved-link";
import type { TransNamespace } from "../types";

export const NotFound404 = () => {
  const { t } = useTranslation<TransNamespace>("transfer:error");

  return (
    <div className="bg-neutral-100">
      <HeaderSwitch />

      <div className={`flex h-screen items-center justify-center `}>
        <div className="max-w-sm p-5 text-center">
          <div className="flex justify-center">
            <WarningSvg className="h-20 w-20 text-neutral-800" />
          </div>
          <h1 className="text-lg font-bold">
            {t("Oops, we got a 404 error.")}
          </h1>
          <p className="text-neutral-800">
            {t(
              "It looks like the page you're looking for has taken a trip of its own.",
            )}
          </p>
          <Button className="mt-4 w-full" asChild>
            <PreservedLink href="/">{t("Take me home")}</PreservedLink>
          </Button>
        </div>
      </div>
    </div>
  );
};
